exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".buy-one-get-one-container{position:relative;width:0;height:0}.buy-one-get-one-container .buy-one-get-one-content{position:absolute;top:5px;left:0;z-index:99;border-radius:15px;font-size:12px;white-space:nowrap;padding:3px 10px;background-color:#fa6400;color:#fff}@media only screen and (max-width:800px){.buy-one-get-one-container{width:100%}.buy-one-get-one-container .buy-one-get-one-content{padding:2px 6px;font-size:9px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-60e1995b","scoped":false,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/buy-one-get-one/buy-one-get-one.vue
// module id = AUaH
// module chunks = 1